import { GuaranteeTypeEnum } from '@insurance/api/requests'
import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber } from '@shared/components'
import { Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { AtaCarnetGoods } from './AtaCarnetGoods'
import { formProps } from './utils'

export const GuaranteeTypeFields = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()

  const {
    guaranteeTypeProps,
    tenderProps,
    tenderObjectProps,
    guaranteedContractProps,
    contractObjectProps,
    customsRegimeProps,
    customsReferenceProps,
    commercialContractProps,
    advanceAmountProps,
    carnetNumberProps,
    requestedAmountProps
  } = formProps(t)

  const guaranteeType = Form.useWatch<GuaranteeTypeEnum>(
    guaranteeTypeProps.name,
    { preserve: true }
  )

  if (!guaranteeType) return null

  if (guaranteeType === GuaranteeTypeEnum.OFFER)
    return (
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...tenderProps} rules={[required]}>
            <Input placeholder={tenderProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...tenderObjectProps} rules={[required]}>
            <Input placeholder={tenderObjectProps.label} />
          </Form.Item>
        </Col>
      </Row>
    )

  if (guaranteeType === GuaranteeTypeEnum.PERFORMANCE)
    return (
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...guaranteedContractProps} rules={[required]}>
            <Input placeholder={guaranteedContractProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...contractObjectProps} rules={[required]}>
            <Input placeholder={contractObjectProps.label} />
          </Form.Item>
        </Col>
      </Row>
    )

  if (guaranteeType === GuaranteeTypeEnum.CUSTOMS)
    return (
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...customsRegimeProps} rules={[required]}>
            <Input placeholder={customsRegimeProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...customsReferenceProps} rules={[required]}>
            <Input placeholder={customsReferenceProps.label} />
          </Form.Item>
        </Col>
      </Row>
    )

  if (guaranteeType === GuaranteeTypeEnum.ADVANCE)
    return (
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...commercialContractProps} rules={[required]}>
            <Input placeholder={commercialContractProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...advanceAmountProps} rules={[required]}>
            <InputParsedNumber
              className="w-full"
              placeholder={advanceAmountProps.label as string}
              min={0.01}
              precision={2}
            />
          </Form.Item>
        </Col>
      </Row>
    )

  // Explicit rather than a fallback: `ata_carnet` is hidden from the select
  // until the backend adds it to IMPLEMENTED_GUARANTEE_TYPES, and an unmatched
  // type must render nothing instead of leaking this block.
  if (guaranteeType === GuaranteeTypeEnum.ATA_CARNET)
    return (
      <>
        <Row gutter={[12, 12]}>
          <Col xs={24} lg={12}>
            <Form.Item {...carnetNumberProps} rules={[required]}>
              <Input placeholder={carnetNumberProps.label} />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item {...requestedAmountProps} rules={[required]}>
              <InputParsedNumber
                className="w-full"
                placeholder={requestedAmountProps.label as string}
                min={0.01}
                precision={2}
              />
            </Form.Item>
          </Col>
        </Row>

        <AtaCarnetGoods />
      </>
    )

  return null
}
